import script from "./ModalFade.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalFade.vue?vue&type=script&setup=true&lang=ts"

import "./ModalFade.vue?vue&type=style&index=0&id=21d4b9d5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d4b9d5"]])

export default __exports__